var C = Object.defineProperty;
var N = (e, t, r) => t in e ? C(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var d = (e, t, r) => N(e, typeof t != "symbol" ? t + "" : t, r);
import * as f from "protobufjs/minimal.js";
import "../sub2/data.js";
import { FeatureSetStatusForSeller as n } from "./feature_sets.js";
import { FeatureStatusForSeller as p } from "./model.js";
const u = "default" in f ? f.default : f;
function S() {
  return { $type: "squareup.featurama.service.BulkRetrieveFeatureSetStatusesRequest", featureSetKeys: [] };
}
const U = {
  $type: "squareup.featurama.service.BulkRetrieveFeatureSetStatusesRequest",
  encode(e, t = u.Writer.create()) {
    t.uint32(10).fork();
    for (const r of e.featureSetKeys)
      t.int32(r);
    return t.ldelim(), t;
  },
  decode(e, t) {
    const r = e instanceof u.Reader ? e : u.Reader.create(e);
    let i = t === void 0 ? r.len : r.pos + t;
    const s = S();
    for (; r.pos < i; ) {
      const a = r.uint32();
      switch (a >>> 3) {
        case 1:
          if (a === 8) {
            s.featureSetKeys.push(r.int32());
            continue;
          }
          if (a === 10) {
            const o = r.uint32() + r.pos;
            for (; r.pos < o; )
              s.featureSetKeys.push(r.int32());
            continue;
          }
          break;
      }
      if ((a & 7) === 4 || a === 0)
        break;
      r.skipType(a & 7);
    }
    return s;
  },
  create(e) {
    return U.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var r;
    const t = S();
    return t.featureSetKeys = ((r = e.featureSetKeys) == null ? void 0 : r.map((i) => i)) || [], t;
  }
};
function R() {
  return {
    $type: "squareup.featurama.service.BulkRetrieveFeatureStatusesRequest",
    keys: [],
    includeSubscriptionMetadata: void 0,
    includeActivationStatuses: void 0,
    consistent: void 0
  };
}
const T = {
  $type: "squareup.featurama.service.BulkRetrieveFeatureStatusesRequest",
  encode(e, t = u.Writer.create()) {
    t.uint32(10).fork();
    for (const r of e.keys)
      t.int32(r);
    return t.ldelim(), e.includeSubscriptionMetadata !== void 0 && c.encode(e.includeSubscriptionMetadata, t.uint32(18).fork()).ldelim(), e.includeActivationStatuses !== void 0 && t.uint32(24).bool(e.includeActivationStatuses), e.consistent !== void 0 && t.uint32(32).bool(e.consistent), t;
  },
  decode(e, t) {
    const r = e instanceof u.Reader ? e : u.Reader.create(e);
    let i = t === void 0 ? r.len : r.pos + t;
    const s = R();
    for (; r.pos < i; ) {
      const a = r.uint32();
      switch (a >>> 3) {
        case 1:
          if (a === 8) {
            s.keys.push(r.int32());
            continue;
          }
          if (a === 10) {
            const o = r.uint32() + r.pos;
            for (; r.pos < o; )
              s.keys.push(r.int32());
            continue;
          }
          break;
        case 2:
          if (a !== 18)
            break;
          s.includeSubscriptionMetadata = c.decode(r, r.uint32());
          continue;
        case 3:
          if (a !== 24)
            break;
          s.includeActivationStatuses = r.bool();
          continue;
        case 4:
          if (a !== 32)
            break;
          s.consistent = r.bool();
          continue;
      }
      if ((a & 7) === 4 || a === 0)
        break;
      r.skipType(a & 7);
    }
    return s;
  },
  create(e) {
    return T.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var r;
    const t = R();
    return t.keys = ((r = e.keys) == null ? void 0 : r.map((i) => i)) || [], t.includeSubscriptionMetadata = e.includeSubscriptionMetadata !== void 0 && e.includeSubscriptionMetadata !== null ? c.fromPartial(e.includeSubscriptionMetadata) : void 0, t.includeActivationStatuses = e.includeActivationStatuses ?? void 0, t.consistent = e.consistent ?? void 0, t;
  }
};
function v() {
  return {
    $type: "squareup.featurama.service.BulkRetrieveFeatureStatusesRequest.IncludeSubscriptionMetadata",
    planGroupToken: void 0
  };
}
const c = {
  $type: "squareup.featurama.service.BulkRetrieveFeatureStatusesRequest.IncludeSubscriptionMetadata",
  encode(e, t = u.Writer.create()) {
    return e.planGroupToken !== void 0 && t.uint32(10).string(e.planGroupToken), t;
  },
  decode(e, t) {
    const r = e instanceof u.Reader ? e : u.Reader.create(e);
    let i = t === void 0 ? r.len : r.pos + t;
    const s = v();
    for (; r.pos < i; ) {
      const a = r.uint32();
      switch (a >>> 3) {
        case 1:
          if (a !== 10)
            break;
          s.planGroupToken = r.string();
          continue;
      }
      if ((a & 7) === 4 || a === 0)
        break;
      r.skipType(a & 7);
    }
    return s;
  },
  create(e) {
    return c.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const t = v();
    return t.planGroupToken = e.planGroupToken ?? void 0, t;
  }
};
function l() {
  return { $type: "squareup.featurama.service.RetrieveFeatureSetStatusRequest", featureSetKey: void 0 };
}
const A = {
  $type: "squareup.featurama.service.RetrieveFeatureSetStatusRequest",
  encode(e, t = u.Writer.create()) {
    return e.featureSetKey !== void 0 && t.uint32(8).int32(e.featureSetKey), t;
  },
  decode(e, t) {
    const r = e instanceof u.Reader ? e : u.Reader.create(e);
    let i = t === void 0 ? r.len : r.pos + t;
    const s = l();
    for (; r.pos < i; ) {
      const a = r.uint32();
      switch (a >>> 3) {
        case 1:
          if (a !== 8)
            break;
          s.featureSetKey = r.int32();
          continue;
      }
      if ((a & 7) === 4 || a === 0)
        break;
      r.skipType(a & 7);
    }
    return s;
  },
  create(e) {
    return A.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const t = l();
    return t.featureSetKey = e.featureSetKey ?? void 0, t;
  }
};
function h() {
  return {
    $type: "squareup.featurama.service.UpdateFeatureSetStatusRequest",
    featureSetKey: void 0,
    activationStatus: void 0
  };
}
const g = {
  $type: "squareup.featurama.service.UpdateFeatureSetStatusRequest",
  encode(e, t = u.Writer.create()) {
    return e.featureSetKey !== void 0 && t.uint32(8).int32(e.featureSetKey), e.activationStatus !== void 0 && t.uint32(16).int32(e.activationStatus), t;
  },
  decode(e, t) {
    const r = e instanceof u.Reader ? e : u.Reader.create(e);
    let i = t === void 0 ? r.len : r.pos + t;
    const s = h();
    for (; r.pos < i; ) {
      const a = r.uint32();
      switch (a >>> 3) {
        case 1:
          if (a !== 8)
            break;
          s.featureSetKey = r.int32();
          continue;
        case 2:
          if (a !== 16)
            break;
          s.activationStatus = r.int32();
          continue;
      }
      if ((a & 7) === 4 || a === 0)
        break;
      r.skipType(a & 7);
    }
    return s;
  },
  create(e) {
    return g.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const t = h();
    return t.featureSetKey = e.featureSetKey ?? void 0, t.activationStatus = e.activationStatus ?? void 0, t;
  }
};
function m() {
  return { $type: "squareup.featurama.service.ActivateFeatureSetRequest", featureSetKey: void 0 };
}
const W = {
  $type: "squareup.featurama.service.ActivateFeatureSetRequest",
  encode(e, t = u.Writer.create()) {
    return e.featureSetKey !== void 0 && t.uint32(8).int32(e.featureSetKey), t;
  },
  decode(e, t) {
    const r = e instanceof u.Reader ? e : u.Reader.create(e);
    let i = t === void 0 ? r.len : r.pos + t;
    const s = m();
    for (; r.pos < i; ) {
      const a = r.uint32();
      switch (a >>> 3) {
        case 1:
          if (a !== 8)
            break;
          s.featureSetKey = r.int32();
          continue;
      }
      if ((a & 7) === 4 || a === 0)
        break;
      r.skipType(a & 7);
    }
    return s;
  },
  create(e) {
    return W.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const t = m();
    return t.featureSetKey = e.featureSetKey ?? void 0, t;
  }
};
function F() {
  return { $type: "squareup.featurama.service.DeactivateFeatureSetRequest", featureSetKey: void 0 };
}
const E = {
  $type: "squareup.featurama.service.DeactivateFeatureSetRequest",
  encode(e, t = u.Writer.create()) {
    return e.featureSetKey !== void 0 && t.uint32(8).int32(e.featureSetKey), t;
  },
  decode(e, t) {
    const r = e instanceof u.Reader ? e : u.Reader.create(e);
    let i = t === void 0 ? r.len : r.pos + t;
    const s = F();
    for (; r.pos < i; ) {
      const a = r.uint32();
      switch (a >>> 3) {
        case 1:
          if (a !== 8)
            break;
          s.featureSetKey = r.int32();
          continue;
      }
      if ((a & 7) === 4 || a === 0)
        break;
      r.skipType(a & 7);
    }
    return s;
  },
  create(e) {
    return E.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const t = F();
    return t.featureSetKey = e.featureSetKey ?? void 0, t;
  }
};
function k() {
  return { $type: "squareup.featurama.service.ReactivateFeatureSetRequest", featureSetKey: void 0 };
}
const j = {
  $type: "squareup.featurama.service.ReactivateFeatureSetRequest",
  encode(e, t = u.Writer.create()) {
    return e.featureSetKey !== void 0 && t.uint32(8).int32(e.featureSetKey), t;
  },
  decode(e, t) {
    const r = e instanceof u.Reader ? e : u.Reader.create(e);
    let i = t === void 0 ? r.len : r.pos + t;
    const s = k();
    for (; r.pos < i; ) {
      const a = r.uint32();
      switch (a >>> 3) {
        case 1:
          if (a !== 8)
            break;
          s.featureSetKey = r.int32();
          continue;
      }
      if ((a & 7) === 4 || a === 0)
        break;
      r.skipType(a & 7);
    }
    return s;
  },
  create(e) {
    return j.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const t = k();
    return t.featureSetKey = e.featureSetKey ?? void 0, t;
  }
};
function y() {
  return { $type: "squareup.featurama.service.BulkRetrieveFeatureSetStatusesResponse", featureSetStatuses: [] };
}
const D = {
  $type: "squareup.featurama.service.BulkRetrieveFeatureSetStatusesResponse",
  encode(e, t = u.Writer.create()) {
    for (const r of e.featureSetStatuses)
      n.encode(r, t.uint32(10).fork()).ldelim();
    return t;
  },
  decode(e, t) {
    const r = e instanceof u.Reader ? e : u.Reader.create(e);
    let i = t === void 0 ? r.len : r.pos + t;
    const s = y();
    for (; r.pos < i; ) {
      const a = r.uint32();
      switch (a >>> 3) {
        case 1:
          if (a !== 10)
            break;
          s.featureSetStatuses.push(n.decode(r, r.uint32()));
          continue;
      }
      if ((a & 7) === 4 || a === 0)
        break;
      r.skipType(a & 7);
    }
    return s;
  },
  create(e) {
    return D.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var r;
    const t = y();
    return t.featureSetStatuses = ((r = e.featureSetStatuses) == null ? void 0 : r.map((i) => n.fromPartial(i))) || [], t;
  }
};
function q() {
  return { $type: "squareup.featurama.service.BulkRetrieveFeatureStatusesResponse", featureStatuses: [] };
}
const M = {
  $type: "squareup.featurama.service.BulkRetrieveFeatureStatusesResponse",
  encode(e, t = u.Writer.create()) {
    for (const r of e.featureStatuses)
      p.encode(r, t.uint32(10).fork()).ldelim();
    return t;
  },
  decode(e, t) {
    const r = e instanceof u.Reader ? e : u.Reader.create(e);
    let i = t === void 0 ? r.len : r.pos + t;
    const s = q();
    for (; r.pos < i; ) {
      const a = r.uint32();
      switch (a >>> 3) {
        case 1:
          if (a !== 10)
            break;
          s.featureStatuses.push(p.decode(r, r.uint32()));
          continue;
      }
      if ((a & 7) === 4 || a === 0)
        break;
      r.skipType(a & 7);
    }
    return s;
  },
  create(e) {
    return M.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var r;
    const t = q();
    return t.featureStatuses = ((r = e.featureStatuses) == null ? void 0 : r.map((i) => p.fromPartial(i))) || [], t;
  }
};
function b() {
  return { $type: "squareup.featurama.service.RetrieveFeatureSetStatusResponse", featureSetStatus: void 0 };
}
const _ = {
  $type: "squareup.featurama.service.RetrieveFeatureSetStatusResponse",
  encode(e, t = u.Writer.create()) {
    return e.featureSetStatus !== void 0 && n.encode(e.featureSetStatus, t.uint32(10).fork()).ldelim(), t;
  },
  decode(e, t) {
    const r = e instanceof u.Reader ? e : u.Reader.create(e);
    let i = t === void 0 ? r.len : r.pos + t;
    const s = b();
    for (; r.pos < i; ) {
      const a = r.uint32();
      switch (a >>> 3) {
        case 1:
          if (a !== 10)
            break;
          s.featureSetStatus = n.decode(r, r.uint32());
          continue;
      }
      if ((a & 7) === 4 || a === 0)
        break;
      r.skipType(a & 7);
    }
    return s;
  },
  create(e) {
    return _.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const t = b();
    return t.featureSetStatus = e.featureSetStatus !== void 0 && e.featureSetStatus !== null ? n.fromPartial(e.featureSetStatus) : void 0, t;
  }
};
function P() {
  return {
    $type: "squareup.featurama.service.UpdateFeatureSetStatusResponse",
    activationStatus: void 0,
    statusUpdated: void 0
  };
}
const w = {
  $type: "squareup.featurama.service.UpdateFeatureSetStatusResponse",
  encode(e, t = u.Writer.create()) {
    return e.activationStatus !== void 0 && t.uint32(8).int32(e.activationStatus), e.statusUpdated !== void 0 && t.uint32(16).bool(e.statusUpdated), t;
  },
  decode(e, t) {
    const r = e instanceof u.Reader ? e : u.Reader.create(e);
    let i = t === void 0 ? r.len : r.pos + t;
    const s = P();
    for (; r.pos < i; ) {
      const a = r.uint32();
      switch (a >>> 3) {
        case 1:
          if (a !== 8)
            break;
          s.activationStatus = r.int32();
          continue;
        case 2:
          if (a !== 16)
            break;
          s.statusUpdated = r.bool();
          continue;
      }
      if ((a & 7) === 4 || a === 0)
        break;
      r.skipType(a & 7);
    }
    return s;
  },
  create(e) {
    return w.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const t = P();
    return t.activationStatus = e.activationStatus ?? void 0, t.statusUpdated = e.statusUpdated ?? void 0, t;
  }
};
function B() {
  return { $type: "squareup.featurama.service.ActivateFeatureSetResponse", statusUpdated: void 0 };
}
const G = {
  $type: "squareup.featurama.service.ActivateFeatureSetResponse",
  encode(e, t = u.Writer.create()) {
    return e.statusUpdated !== void 0 && t.uint32(8).bool(e.statusUpdated), t;
  },
  decode(e, t) {
    const r = e instanceof u.Reader ? e : u.Reader.create(e);
    let i = t === void 0 ? r.len : r.pos + t;
    const s = B();
    for (; r.pos < i; ) {
      const a = r.uint32();
      switch (a >>> 3) {
        case 1:
          if (a !== 8)
            break;
          s.statusUpdated = r.bool();
          continue;
      }
      if ((a & 7) === 4 || a === 0)
        break;
      r.skipType(a & 7);
    }
    return s;
  },
  create(e) {
    return G.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const t = B();
    return t.statusUpdated = e.statusUpdated ?? void 0, t;
  }
};
function K() {
  return { $type: "squareup.featurama.service.DeactivateFeatureSetResponse" };
}
const I = {
  $type: "squareup.featurama.service.DeactivateFeatureSetResponse",
  encode(e, t = u.Writer.create()) {
    return t;
  },
  decode(e, t) {
    const r = e instanceof u.Reader ? e : u.Reader.create(e);
    let i = t === void 0 ? r.len : r.pos + t;
    const s = K();
    for (; r.pos < i; ) {
      const a = r.uint32();
      if ((a & 7) === 4 || a === 0)
        break;
      r.skipType(a & 7);
    }
    return s;
  },
  create(e) {
    return I.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return K();
  }
};
function $() {
  return { $type: "squareup.featurama.service.ReactivateFeatureSetResponse" };
}
const x = {
  $type: "squareup.featurama.service.ReactivateFeatureSetResponse",
  encode(e, t = u.Writer.create()) {
    return t;
  },
  decode(e, t) {
    const r = e instanceof u.Reader ? e : u.Reader.create(e);
    let i = t === void 0 ? r.len : r.pos + t;
    const s = $();
    for (; r.pos < i; ) {
      const a = r.uint32();
      if ((a & 7) === 4 || a === 0)
        break;
      r.skipType(a & 7);
    }
    return s;
  },
  create(e) {
    return x.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return $();
  }
}, z = "squareup.featurama.service.FeaturamaService";
class Q {
  constructor(t, r) {
    d(this, "rpc");
    d(this, "service");
    this.service = (r == null ? void 0 : r.service) || z, this.rpc = t, this.bulkRetrieveFeatureSetStatuses = this.bulkRetrieveFeatureSetStatuses.bind(this), this.bulkRetrieveFeatureStatuses = this.bulkRetrieveFeatureStatuses.bind(this), this.retrieveFeatureSetStatus = this.retrieveFeatureSetStatus.bind(this), this.updateFeatureSetStatus = this.updateFeatureSetStatus.bind(this), this.activateFeatureSet = this.activateFeatureSet.bind(this), this.deactivateFeatureSet = this.deactivateFeatureSet.bind(this), this.reactivateFeatureSet = this.reactivateFeatureSet.bind(this);
  }
  bulkRetrieveFeatureSetStatuses(t) {
    const r = U.encode(t).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "BulkRetrieveFeatureSetStatuses", t), this.rpc.request(this.service, "BulkRetrieveFeatureSetStatuses", r).then((s) => {
      try {
        const a = D.decode(u.Reader.create(s));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "BulkRetrieveFeatureSetStatuses", a), a;
      } catch (a) {
        return Promise.reject(a);
      }
    }).catch((s) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "BulkRetrieveFeatureSetStatuses", s)) : Promise.reject(s));
  }
  bulkRetrieveFeatureStatuses(t) {
    const r = T.encode(t).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "BulkRetrieveFeatureStatuses", t), this.rpc.request(this.service, "BulkRetrieveFeatureStatuses", r).then((s) => {
      try {
        const a = M.decode(u.Reader.create(s));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "BulkRetrieveFeatureStatuses", a), a;
      } catch (a) {
        return Promise.reject(a);
      }
    }).catch((s) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "BulkRetrieveFeatureStatuses", s)) : Promise.reject(s));
  }
  retrieveFeatureSetStatus(t) {
    const r = A.encode(t).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "RetrieveFeatureSetStatus", t), this.rpc.request(this.service, "RetrieveFeatureSetStatus", r).then((s) => {
      try {
        const a = _.decode(u.Reader.create(s));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "RetrieveFeatureSetStatus", a), a;
      } catch (a) {
        return Promise.reject(a);
      }
    }).catch((s) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "RetrieveFeatureSetStatus", s)) : Promise.reject(s));
  }
  updateFeatureSetStatus(t) {
    const r = g.encode(t).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "UpdateFeatureSetStatus", t), this.rpc.request(this.service, "UpdateFeatureSetStatus", r).then((s) => {
      try {
        const a = w.decode(u.Reader.create(s));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "UpdateFeatureSetStatus", a), a;
      } catch (a) {
        return Promise.reject(a);
      }
    }).catch((s) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "UpdateFeatureSetStatus", s)) : Promise.reject(s));
  }
  activateFeatureSet(t) {
    const r = W.encode(t).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ActivateFeatureSet", t), this.rpc.request(this.service, "ActivateFeatureSet", r).then((s) => {
      try {
        const a = G.decode(u.Reader.create(s));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ActivateFeatureSet", a), a;
      } catch (a) {
        return Promise.reject(a);
      }
    }).catch((s) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ActivateFeatureSet", s)) : Promise.reject(s));
  }
  deactivateFeatureSet(t) {
    const r = E.encode(t).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "DeactivateFeatureSet", t), this.rpc.request(this.service, "DeactivateFeatureSet", r).then((s) => {
      try {
        const a = I.decode(u.Reader.create(s));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "DeactivateFeatureSet", a), a;
      } catch (a) {
        return Promise.reject(a);
      }
    }).catch((s) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "DeactivateFeatureSet", s)) : Promise.reject(s));
  }
  reactivateFeatureSet(t) {
    const r = j.encode(t).finish();
    return this.rpc.beforeRequest && this.rpc.beforeRequest(this.service, "ReactivateFeatureSet", t), this.rpc.request(this.service, "ReactivateFeatureSet", r).then((s) => {
      try {
        const a = x.decode(u.Reader.create(s));
        return this.rpc.afterResponse && this.rpc.afterResponse(this.service, "ReactivateFeatureSet", a), a;
      } catch (a) {
        return Promise.reject(a);
      }
    }).catch((s) => this.rpc.handleError ? Promise.reject(this.rpc.handleError(this.service, "ReactivateFeatureSet", s)) : Promise.reject(s));
  }
}
export {
  W as ActivateFeatureSetRequest,
  G as ActivateFeatureSetResponse,
  U as BulkRetrieveFeatureSetStatusesRequest,
  D as BulkRetrieveFeatureSetStatusesResponse,
  T as BulkRetrieveFeatureStatusesRequest,
  c as BulkRetrieveFeatureStatusesRequest_IncludeSubscriptionMetadata,
  M as BulkRetrieveFeatureStatusesResponse,
  E as DeactivateFeatureSetRequest,
  I as DeactivateFeatureSetResponse,
  Q as FeaturamaServiceClientImpl,
  z as FeaturamaServiceServiceName,
  j as ReactivateFeatureSetRequest,
  x as ReactivateFeatureSetResponse,
  A as RetrieveFeatureSetStatusRequest,
  _ as RetrieveFeatureSetStatusResponse,
  g as UpdateFeatureSetStatusRequest,
  w as UpdateFeatureSetStatusResponse
};
